<template>
  <div class="act_countdown_wrap" :style="wrap_style" v-if="is_show">
    倒计时&nbsp;&nbsp;
    <template v-if="countDownTime.day !== '00'">
      <div class="number" v-for="item in countDownTime.day" :style="numStyle">
        {{item}}
      </div>
      天&nbsp;
    </template>

    <div class="number" v-for="item in countDownTime.hour" :style="numStyle">
      {{item}}
    </div>
    时&nbsp;
    <div class="number" :style="numStyle">
      {{countDownTime.minute[0]}}
    </div>
    <div class="number" :style="numStyle">
      {{countDownTime.minute[1]}}
    </div>
    分&nbsp;
    <div class="number" :style="numStyle">
      {{countDownTime.second[0]}}
    </div>
    <div class="number" :style="numStyle">
      {{countDownTime.second[1]}}
    </div>
    秒&nbsp;

    <template v-if="countDownTime.day === '00'">
      <div class="number" :style="numStyle" >
        {{countDownTime.tenMs[0]}}
      </div>
      <div class="number" :style="numStyle">
        {{countDownTime.tenMs[1]}}
      </div>
      &nbsp;
      &nbsp;
      &nbsp;
    </template>

  </div>
  <div class="act_countdown_wrap_no_show" v-else>

  </div>
</template>
<script>
  import {getJSON} from '../../api/myaxios';
  import handler_action from '../../tools/mgtv/action'
  import click_handler from '../../tools/mgtv/click'
  import {countDown} from "../../tools/countdown";
  import {onUseInfoLoad} from "../../tools/onUseInfoLoad";
  import {ACT_RUNNING} from '../../constant/act_stat'

  export default {
    name: 'ActCountDown',
    props: ['info'],
    data() {
      return {
        diff: 0,
        end_time: null
      }
    },

    created() {

    },
    methods: {
      updateTime() {

        this.diff = this.end_time - new Date();
        if (this.diff <= 0) {

          console.log('count down end')

          window.clearInterval(this.inter);
          this.inter = null;

          //活动期间才会自动执行,非强制等待用户信息获取后调用
          onUseInfoLoad(() => {
            click_handler(`倒计时${this.info.id}自动事件`, () => {
              if (this.info.action_type) {
                handler_action(this.info);
              }
            }, {
              need_login: this.info.action_info.need_login,
              need_act: this.info.action_info.need_act,
              need_new_user: this.info.action_info.need_new_user,
              need_vip_level: this.info.action_info.need_vip_level,
            });
          }, false);
        }
        ;
      }
    },
    computed: {
      countDownTime() {

        return countDown(this.diff,true);
      },
      wrap_style() {
        return {
          color: `${this.info.cd_text_color} !important`
        }
      },
      numStyle() {
        return {
          color: `${this.info.cd_num_color} !important`,
          background: `url(${this.info.cd_num_bg}) 0% 0% / cover no-repeat`
        }
      },
      is_show() {
        return this.info.cd_show
      }

    },
    mounted() {

      this.end_time = null;
      let end_time_str = '';
      if (this.info.cd_end_time_same_as_act) { //和结束时间相同
        end_time_str = window.$bus.act.end_time
      } else {
        end_time_str = this.info.cd_end_time;
      }
      if (end_time_str) {

        this.end_time = new Date(end_time_str.replace(/-/g, '/'));

        this.inter = window.setInterval(() => {
          this.updateTime();
        }, 1 / 3);
        console.log('count down running')
      } else {
        console.error('倒计时无结束时间');
      }
    },
    destroyed() {
      window.clearInterval(this.inter);
    },
    watch: {}
  }
</script>
<style lang="stylus" scoped>
  .act_countdown_wrap_no_show
    position relative

  .act_countdown_wrap
    width 7.5rem
    justify-content center
    position relative
    display flex
    align-items center
    height .7rem
    font-size .28rem

    .number
      width .49rem
      height .7rem
      display block
      line-height @height
      text-align center
      margin 0 .02rem
      font-size .36rem


</style>






// WEBPACK FOOTER //
// src/components/ConfigUI/ActCountDown.vue